import { CrntElement } from '../../lib/crnt-element.js';
import { trustedCSS } from '../../lib/css/css.js';
import { CrntCheckableFormControlGroupMixin } from '../checkable-form-control-group/checkable-form-control-group.component.js';
import checkableFormControlGroupStyles from '../checkable-form-control-group/checkable-form-control-group.css.js';
import { CrntCheckbox } from '../checkbox/checkbox.component.js';

const CrntCheckableFormControlGroup = CrntCheckableFormControlGroupMixin(CrntElement, {
  checkableFormControlSelector: CrntCheckbox.tagName,
  checkableFormControlSelectorBorderedSelector: `${CrntCheckbox.tagName}[bordered]`,
  linkSlottedFormElementsControllerOptions: {
    selectors: {
      crntInput: ":not([slot]):is(crnt-checkbox)",
      help: `[slot="help"]:not(${CrntCheckbox.tagName} [slot="help"])`,
      input: ":not([slot]):is(input[type=checkbox])",
      validation: `[slot="validation"]:not(${CrntCheckbox.tagName} [slot="validation"])`
    }
  }
});
class CrntCheckboxGroup extends CrntCheckableFormControlGroup {
  static {
    this.styles = [trustedCSS(checkableFormControlGroupStyles)];
  }
  static {
    this.tagName = "crnt-checkbox-group";
  }
}

export { CrntCheckboxGroup };
